import { computed, defineComponent, useCssModule } from '@nuxtjs/composition-api';
import { useA11y } from '~/composables';
export default defineComponent({
    name: 'A11yButton',
    inheritAttrs: false,
    props: {
        tooltip: {
            default: () => ({}),
            type: Object,
        },
    },
    setup(props) {
        /**
         * Accessibility
         */
        const a11y = useA11y();
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const tooltipOptions = computed(() => {
            return {
                ...{
                    gap: '22px',
                    padding: '0',
                    position: 'left',
                },
                ...props.tooltip,
            };
        });
        function handleClick() {
            if (a11y.isEnabled) {
                a11y.isBarVisible = !a11y.isBarVisible;
                return;
            }
            a11y.isEnabled = true;
            a11y.isBarVisible = true;
        }
        return {
            a11y,
            css,
            tooltipOptions,
            handleClick,
        };
    },
});
